import XHR         from "_common/xhr";
import { configs } from "_config/index";

export const isValidCoupon = async function ( params ) {
	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.COUPONS }coupons/pro/isValidCoupon?code=${ params?.code }&pId=${ params?.productId }`
	} );

	return response;
};
